export { Switch, type SwitchProps } from './switch';
